// import AppConfiguration from "../assets/Configuration/ConfigurationFile.json"

//const BASE_URL = "http://144.217.79.9:80/servlet/evinsysnext.application.webconfig.";

// beta
// const SERVER_NAME = "http://beta.welllynx.com";
// const SERVER_PORT = "8055";

// app wellLynx
// const SERVER_NAME = "http://app.welllynx.com";
// const SERVER_PORT = "8080";

// haladmin
const SERVER_NAME="https://intelevateadmin.halliburton.com";
const SERVER_PORT="443";

// agoco
// const SERVER_NAME = "http://agocoadmin.welllynx.com";
// const SERVER_PORT = "80";

// Drivelynx
// const SERVER_NAME = "https://aid.welllynx.com";
// const SERVER_PORT = "80";

// Stage
// const SERVER_NAME = "https://stage.welllynx.com";
// const SERVER_PORT = "8055";
// const SERVER_NAME="http://142.4.219.125";
// const SERVER_PORT="8080"


// influx test 
// const SERVER_NAME="http://15.235.80.181";
// const SERVER_PORT="8080"

// KOC test
// const SERVER_NAME="http://192.168.1.205";
// const SERVER_PORT="80"

// NOVOMET
// const SERVER_NAME="http://novomet.welllynx.com"
// const SERVER_PORT="8055"

// Endurance
// const SERVER_NAME="https://endurance.welllynx.com"
// const SERVER_PORT="80"

// Agoco Local Environment
// const SERVER_NAME="https://10.4.3.34";
// const SERVER_PORT="443";

// Landmark
// const SERVER_NAME="https://intelevatedfs.halliburton.com";
// const SERVER_PORT="8080";

// inteliftStage
// const SERVER_NAME="https://inteliftstage.welllynx.com";
// const SERVER_PORT="80";

// test local
// const SERVER_NAME="http://localhost";
// const SERVER_PORT="80";

// Agoco VPN
// const SERVER_NAME="https://whm.agoco.com";
// const SERVER_PORT="80";

// Mellitah
// const SERVER_NAME = "https://mellitah.welllynx.com";
// const SERVER_PORT = "80";

// Alitheflow
// const SERVER_NAME="https://alitheflow.welllynx.com";
// const SERVER_PORT="80";

// Akakus
// const SERVER_NAME="https://akakus.welllynx.com";
// const SERVER_PORT="80";

const RMQ_PORT = "15674";

// const BASE_URL=`${getCurrentURL()}/service/evinsysnext.application.webconfig.`;
const BACKEND_URL = `${SERVER_NAME}:${SERVER_PORT}`;
const BASE_URL = `${SERVER_NAME}:${SERVER_PORT}/service/evinsysnext.application.webconfig.`; //${getCurrentURL()} for production
const RABBITMQ_URL = `ws:/rmq.welllynx.com:${RMQ_PORT}/ws`;

//const BASE_URL = `${process.env.REACT_APP_SERVER_URL}`;
//const RABBITMQ_URL = `${process.env.REACT_APP_RABBITMQ_SERVER_URL}`;

const RABBITMQ_QUEUE_NAME = `${process.env.REACT_APP_RABBITMQ_QUEUE_NAME}`;
const RABBITMQ_EXCHANGE_NAME = `${process.env.REACT_APP_RABBITMQ_EXCHANGE_NAME}`;
const RABBITMQ_COMM_EXCHANGE_NAME = `${process.env.REACT_APP_RABBITMQ_COMM_EXCHANGE_NAME}`;
const RABBITMQ_ROUTING_KEY = `${process.env.REACT_APP_RABBITMQ_ROUTING_KEY}`;

/*RabitMQ UserName and Password to get access to the admin console of RabbitMQ*/
const RABBITMQ_USERNAME = `${process.env.REACT_APP_RABBITMQ_USERNAME}`;
const RABBITMQ_PASSWORD = `${process.env.REACT_APP_RABBITMQ_PASSWORD}`;

/* ML Manager Url */
const ML_MANAGER_URL = `${BACKEND_URL}/service/ML/`

/* Spring Services */
const BASE_SERVICES_URL = `${SERVER_NAME}:${SERVER_PORT}/service/`

export default {
  AUTH_URL: BASE_URL + "WSAutenService",
  SHOWPREVIEW_URL: BASE_URL + "well.WSPreview",
  LOGIN: "LOGIN",

  USER_URL: BASE_URL + "user.WSUsers",
  LOAD_ALL_USERS: "LOAD_ALL_USERS",
  LOAD_USER: "LOAD_USER",
  LOAD_GROUPS_BY_USER: "LOAD_GROUPS_BY_USER",
  ADD_USER: "ADD_USER",
  UPDATE_USER: "UPDATE_USER",
  DELETE_USER: "DELETE_USER",

  PRODUCER_URL: BASE_URL + "producer.WSProducer",

  GROUPS_URL: BASE_URL + "group.WSGroups",
  LOAD_ALL_GROUPS: "LOAD_ALL_GROUPS",
  LOAD_GROUP: "LOAD_GROUP",
  ADD_GROUP: "ADD_GROUP",
  UPDATE_GROUP: "UPDATE_GROUP",
  DELETE_GROUP: "DELETE_GROUP",
  LOAD_USERS_BY_GROUP: "LOAD_USERS_BY_GROUP",
  LOAD_ASSETS_BY_GROUP: "LOAD_ASSETS_BY_GROUP",
  ADD_USERS_IN_GROUP: "ADD_USERS_IN_GROUP",
  DELETE_USER_FROM_GROUP: "DELETE_USER_FROM_GROUP",

  TAGS_URL: BASE_URL + "tag.WSTag",
  LOAD_ALL_TAGS: "LOAD_ALL_TAGS",
  LOAD_TAG: "LOAD_TAG",
  ADD_TAG: "ADD_TAG",
  UPDATE_TAG: "UPDATE_TAG",
  DELETE_TAG: "DELETE_TAG",

  ADD_TAGS_TO_WELL: "ADD_TAGS_TO_WELL",
  REMOVE_TAGS_FROM_WELL: "REMOVE_TAGS_FROM_WELL",
  REMOVE_TAG_FROM_WELL: "REMOVE_TAG_FROM_WELL",
  LOAD_TAGS_BY_WELL: "LOAD_TAGS_BY_WELL",

  STATE_TAGS_URL: BASE_URL + "stateTag.WSStateTag",

  FIELD_URL: BASE_URL + "field.WSField",
  LOAD_ALL_FIELDS: "LOAD_ALL_FIELDS",
  LOAD_FIELD: "LOAD_FIELD",
  LOAD_WELLS_BY_FIELD: "LOAD_WELLS_BY_FIELD",
  ADD_FIELD: "ADD_FIELD",
  UPDATE_FIELD: "UPDATE_FIELD",
  DELETE_FIELD: "DELETE_FIELD",

  SCHEDULE_URL: BASE_URL + "scheduler.WSScheduler",
  INITIAL_LOAD_SCHEDULE: "INITIAL_LOAD_SCHEDULE",
  LOAD_SCHEDULE: "LOAD_SCHEDULE",
  LOAD_SCHEDS_BY_WELL: "LOAD_SCHEDS_BY_WELL",
  ADD_SCHEDULE: "ADD_SCHEDULE",
  UPDATE_SCHEDULE: "UPDATE_SCHEDULE",
  DELETE_SCHEDULE: "DELETE_SCHEDULE",

  // All global constants
  WL_GLOBAL_URL: BASE_URL + "well.WSGlobalDevice",
  WL_MODBUS_CONF_URL: BASE_URL + "modbusRegister.WSModbusRegister",
  LOAD_TAGS_BY_SCHEDULER: "LOAD_TAGS_BY_SCHEDULER",
  LOAD_ALL_WELLS: "LOAD_ALL_WELLS",
  WL_PASTE_DEVICE: "WL_PASTE_DEVICE",
  WL_LOAD_DEVICE: "WL_LOAD_DEVICE",
  WL_ADD_DEVICE: "WL_ADD_DEVICE",
  WL_UPDATE_DEVICE: "WL_UPDATE_DEVICE",
  LOAD_ALL_WELLS_BY_TYPE_KEY: "LOAD_ALL_WELLS_BY_TYPE_KEY",
  LOAD_DEVICE_TYPES: "LOAD_DEVICE_TYPES",
  LOAD_DEVICES_BY_LIFT_TYPE_KEY: "LOAD_DEVICES_BY_LIFT_TYPE_KEY",
  BULK_ENABLE_DISABLE_DEVICES: "BULK_ENABLE_DISABLE_DEVICES",
  BULK_DELETE_DEVICES: "BULK_DELETE_DEVICES",

  // Sub Types url
  SUBTYPE: BASE_URL + "subTypes.WSSubType",
  //Machine Learning URL
  ML_URL: BASE_URL + "scheduler.WSMachineLearning",
  ML_LOAD_MODELS: "ML_LOAD_MODELS",
  IMPORT_MODEL: "IMPORT_MODEL",
  UPDATE_MODEL: "UPDATE_MODEL",
  DELETE_MODEL: "DELETE_MODEL",

  KSTR_KEY_SIZE: 128,
  KSTR_ITERATION_COUNT: 1000,
  KSTR_PASSE_PHRASE:
    "7B9D46CB34BC2BBB03E460928054F2A0596983C24D58D4AED5DF212C9094DC27",

  /* URL for the rabbitMQ Server with the PORT */
  //STOMP_CLIENT_SERVER_WS: 'ws://'+ window.location.hostname +':15674/ws',
  STOMP_CLIENT_SERVER_WS: RABBITMQ_URL,

  KSTR_QUEUE_NAME: RABBITMQ_QUEUE_NAME,
  KSTR_EXCHANGE_NAME: RABBITMQ_EXCHANGE_NAME,
  KSTR_COMM_EXCHANGE_NAME: RABBITMQ_COMM_EXCHANGE_NAME,
  KSTR_ROUTING_KEY: RABBITMQ_ROUTING_KEY,

  /*RabitMQ UserName and Password to get access to the admin console of RabbitMQ*/
  RABBITMQ_USERNAME: RABBITMQ_USERNAME,
  RABBITMQ_PASSWORD: RABBITMQ_PASSWORD,

  ALL_DEVICE_TYPES_LIFT_TYPE_KEY: -1,
  GENERIC_DEVICE_TYPES_LIFT_TYPE_KEY: 0,
  SRP_DEVICE_TYPES_LIFT_TYPE_KEY: 1,
  ESP_DEVICE_TYPES_LIFT_TYPE_KEY: 2,
  HORIZ_PUMP_DEVICE_TYPES_LIFT_TYPE_KEY: 3,
  SKID_DEVICE_TYPES_LIFT_TYPE_KEY: 4,

  // for testing genericML
  GET_SAVED_MODELS_URL: ML_MANAGER_URL + 'getModels',
  UPDATE_MODEL_URL: ML_MANAGER_URL + 'updateModel',
  DELETE_MODEL_URL: ML_MANAGER_URL + 'deleteModels',

  // Procesed Files
  PROCESSED_FILES_URL: BACKEND_URL + "/filesBackUp",


  // Keycloak Sever
  // KEYCLOAK_SERVER:"https://accounts.welllynx.com", // dfs prod keycloak
  KEYCLOAK_SERVER:"https://intelevateapps.halliburton.com",// Hall prod keycloak
  // KEYCLOAK_SERVER:"https://inteliftstage.welllynx.com:8443" ,// dfs stage keycloak

  
  // Health Index
  // LOAD_ALL_HEALTH_INDEXES: BASE_SERVICES_URL + "espHealth/templates",
  // DELETE_HEALTH_INDEX: BASE_SERVICES_URL + "espHealth/templates",
  // CREATE_HEALTH_INDEX: BASE_SERVICES_URL + "espHealth/templates",
  // UPDATE_HEALTH_INDEX: BASE_SERVICES_URL + "espHealth/templates",
  // GET_HEALTH_INDEX_BY_ID: BASE_SERVICES_URL + "espHealth/templates",
  HEALTH_INDEX_URL:BASE_SERVICES_URL + "espHealth/templates",
  // HEALTH_INDEX_URL:"http://localhost:4000/hiTemplates",
  // GET_HEALTH_INDEX_BY_ID: "https://af88f636-940d-4bdc-ad9a-be401264bd81.mock.pstmn.io/getTemplateByID",
  LUTZ_URL:BASE_SERVICES_URL + "espLutz/templates"
};

function getCurrentURL() {
  return window.location.protocol + "//" + window.location.host;
}
